export default __webpack_public_path__ + "static/media/desktop_banner_miscellaneous.c1430718.jpg";